// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductsList_list__9iMd4","empty":"ProductsList_empty__f3LMI"};